<template>
    <div class="dashboard-block" v-if="!booking.is_offer">
        <h2>Marketing Source</h2>
        <h3>Booking Source</h3>
        <div class="form-item__row">
            <booking-source-common :source="source"/>
            <div class="form-item__field">
              <div class="input-group input-group-booking-detail">
                <span class="input-group-addon">Admin Source</span>
                <selectize
                  class="selectize selectize-control selectize-single"
                  name="marketing_source_admin"
                  :disable-delete="true"
                  :options="marketingSourceOptions"
                  v-model="source.campaign_admin_source"/>
              </div>
            </div>
            <div class="form-item__field">
              <div class="input-group input-group-booking-detail">
                <span class="input-group-addon">Market Segment</span>
                <selectize
                  class="selectize selectize-control selectize-single"
                  name="market-segment-admin"
                  :disable-delete="true"
                  :options="marketSegmentOptions"
                  v-model="booking.market_segment"/>
              </div>
            </div>
            <div class="form-item__field">
              <div class="input-group input-group-booking-detail">
                <span class="input-group-addon">Request Type</span>
                <selectize
                  key="opportunity"
                  class="selectize selectize-single"
                  name="opportunity_id"
                  v-model="booking.admin_opportunity_id"
                  :options="opportunityOptions"/>
              </div>
            </div>
            <div class="form-item__field" v-if="booking.market_segment">
              <div class="input-group input-group-booking-detail">
                <span class="input-group-addon">Sub-category</span>
                <selectize
                  class="selectize selectize-control selectize-single"
                  name="market-segment-subcategory-admin"
                  :disable-delete="true"
                  :options="marketSegmentSubcategoryOptions"
                  v-model="booking.market_segment_subcategory"/>
              </div>
            </div>
            <div class="w-full m-t-lg m-b-lg">
              <ladda-button
                type="submit"
                class="btn btn-primary"
                :click="handleSaveCampaignSourceCallback">
                Save Changes
              </ladda-button>
            </div>
        </div>
      <hr/>
      <h3 v-if="firstSource">Client First Source</h3>
      <div class="row" v-if="firstSource">
        <booking-source-common :source="firstSource"/>
      </div>
    </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
import { mapActions, mapState } from 'vuex'
import { notify } from 'utils'
import Selectize from '../ext/codium/CodiumSelectize'
import { map } from 'lodash'
import BookingSourceCommon from './BookingSourceCommon'

export default {
  name: 'BookingSource',
  mixins: [helpers],

  components: {
    BookingSourceCommon,
    Selectize
  },

  data () {
    return {
      opportunityOptions: []
    }
  },

  computed: {
    ...mapState('booking/source', ['source', 'firstSource']),

    marketingSourceOptions () {
      return [
        { id: 'google', text: 'Google' },
        { id: 'facebook_ads', text: 'Facebook Ads' },
        { id: 'previous_client', text: 'Previous Client' },
        { id: 'linkedIn', text: 'LinkedIn' },
        { id: 'instagram', text: 'Instagram' },
        { id: 'influencer', text: 'Athlete Influencer' },
        { id: 'email', text: 'Email' },
        { id: 'television', text: 'Television' },
        { id: 'referral', text: 'Referral' },
        { id: 'outbound', text: 'Outbound' },
        { id: 'field_sales', text: 'Field Sales' },
        { id: 'test', text: 'Test' }
      ]
    },

    marketSegmentOptions () {
      return [
        { id: 'agency', text: 'Agency' },
        { id: 'association', text: 'Association' },
        { id: 'club', text: 'Club' },
        { id: 'corporate', text: 'Corporate' },
        { id: 'individual', text: 'Individual' },
        { id: 'school', text: 'School' }
      ]
    },

    marketSegmentSubcategoryOptions () {
      switch (this.booking.market_segment) {
        case ('agency'):
          return [
            { id: 'independent', text: 'Independent' },
            { id: 'consortium', text: 'Consortium' },
            { id: 'publishers', text: 'Publishers' },
            { id: 'event_planners', text: 'Event Planners' }
          ]
        case ('association'):
          return [
            { id: 'nfp', text: 'NFP' },
            { id: 'industry_bodies', text: 'Industry Bodies' },
            { id: 'government', text: 'Government' }
          ]
        case ('club'):
          return [
            { id: 'sporting_club', text: 'Sporting Club' },
            { id: 'other', text: 'Other' }
          ]
        case ('corporate'):
          return [
            { id: 'sme', text: 'SME' },
            { id: 'enterprise', text: 'Enterprise' },
            { id: 'startup_sole_trader', text: 'Start Up/Sole Trader' }
          ]
        case ('individual'):
          return [
            { id: 'fan_female', text: 'Fan (Female)' },
            { id: 'fan_male', text: 'Fan (Male)' }
          ]
        case ('school'):
          return [
            { id: 'tertiary', text: 'Tertiary' },
            { id: 'rto', text: 'RTO' },
            { id: 'high_school', text: 'High School' },
            { id: 'primary_school', text: 'Primary School' },
            { id: 'early_learning', text: 'Early Learning' }
          ]
        default:
          return []
      }
    }
  },

  props: {
    booking: {
      type: Object,
      required: true
    }
  },

  methods: {
    ...mapActions('booking/source', ['getBookingSource', 'updateBookingSource']),
    ...mapActions('opportunity', ['getOpportunities']),

    handleSaveCampaignSourceCallback () {
      return this.updateBookingSource({
        id: this.booking.id,
        payload: {
          email: this.booking.client.email,
          campaign_admin_source: this.source.campaign_admin_source,
          market_segment: this.booking.market_segment,
          market_segment_subcategory: this.booking.market_segment_subcategory,
          admin_opportunity_id: this.booking.admin_opportunity_id
        }
      }).then(() => {
        notify.success('Successfully saved campaign source changes.')
      }).catch((errors) => {
        notify.error('Sorry something has gone wrong, please try again.')
      })
    }
  },

  created () {
    this.getBookingSource(this.booking.id)
    this.getOpportunities({'level': 'all'})
      .then((response) => {
        this.opportunityOptions = map(response.data, opportunity => ({ id: opportunity.id, text: opportunity.name }))
      })
  }
}
</script>

<style scoped>

</style>
